import { render, staticRenderFns } from "./ModalPayment.vue?vue&type=template&id=5805a346"
import script from "./ModalPayment.vue?vue&type=script&lang=js"
export * from "./ModalPayment.vue?vue&type=script&lang=js"
import style0 from "./ModalPayment.vue?vue&type=style&index=0&id=5805a346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports